/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */

import { Contract, Signer, utils } from "ethers";
import { Provider } from "@ethersproject/providers";
import type {
  UniswapV3PriceProviderV3,
  UniswapV3PriceProviderV3Interface,
} from "../UniswapV3PriceProviderV3";

const _abi = [
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "uint8",
        name: "blockTime",
        type: "uint8",
      },
    ],
    name: "NewBlockTime",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "uint32",
        name: "period",
        type: "uint32",
      },
    ],
    name: "NewPeriod",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "newPendingOwner",
        type: "address",
      },
    ],
    name: "OwnershipPending",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "newOwner",
        type: "address",
      },
    ],
    name: "OwnershipTransferred",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "asset",
        type: "address",
      },
      {
        indexed: false,
        internalType: "contract IUniswapV3Pool[]",
        name: "pools",
        type: "address[]",
      },
    ],
    name: "PoolsForAsset",
    type: "event",
  },
  {
    inputs: [],
    name: "MAX_ACCEPTED_BLOCK_TIME",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "QUOTE_TOKEN_DECIMALS",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "acceptOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "contract IUniswapV3Pool[]",
        name: "_pools",
        type: "address[]",
      },
    ],
    name: "adjustOracleCardinality",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_asset",
        type: "address",
      },
    ],
    name: "assetOldestTimestamp",
    outputs: [
      {
        internalType: "uint32[]",
        name: "oldestTimestamps",
        type: "uint32[]",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_asset",
        type: "address",
      },
    ],
    name: "assetSupported",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint8",
        name: "_blockTime",
        type: "uint8",
      },
    ],
    name: "changeBlockTime",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint32",
        name: "_period",
        type: "uint32",
      },
    ],
    name: "changePeriodForAvgPrice",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_asset",
        type: "address",
      },
    ],
    name: "getPrice",
    outputs: [
      {
        internalType: "uint256",
        name: "price",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "contract IUniswapV3Pool",
        name: "_pool",
        type: "address",
      },
    ],
    name: "observationsStatus",
    outputs: [
      {
        internalType: "bool",
        name: "bufferFull",
        type: "bool",
      },
      {
        internalType: "bool",
        name: "enoughObservations",
        type: "bool",
      },
      {
        internalType: "uint16",
        name: "currentCardinality",
        type: "uint16",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "owner",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "pendingOwner",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_asset",
        type: "address",
      },
    ],
    name: "pools",
    outputs: [
      {
        components: [
          {
            internalType: "contract IUniswapV3Pool",
            name: "pool",
            type: "address",
          },
          {
            internalType: "bool",
            name: "token0IsInterim",
            type: "bool",
          },
        ],
        internalType: "struct UniswapV3PriceProviderV3.PricePath[]",
        name: "",
        type: "tuple[]",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "priceCalculationData",
    outputs: [
      {
        internalType: "uint32",
        name: "periodForAvgPrice",
        type: "uint32",
      },
      {
        internalType: "uint8",
        name: "blockTime",
        type: "uint8",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "priceProviderPing",
    outputs: [
      {
        internalType: "bytes4",
        name: "",
        type: "bytes4",
      },
    ],
    stateMutability: "pure",
    type: "function",
  },
  {
    inputs: [],
    name: "priceProvidersRepository",
    outputs: [
      {
        internalType: "contract IPriceProvidersRepository",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "contract IUniswapV3Pool",
        name: "_pool",
        type: "address",
      },
    ],
    name: "quotePrice",
    outputs: [
      {
        internalType: "uint256",
        name: "price",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "quoteToken",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "removePendingOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "renounceOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "contract IUniswapV3Pool",
        name: "_pool",
        type: "address",
      },
      {
        internalType: "uint16",
        name: "_currentObservationIndex",
        type: "uint16",
      },
      {
        internalType: "uint16",
        name: "_currentObservationCardinality",
        type: "uint16",
      },
    ],
    name: "resolveOldestObservationTimestamp",
    outputs: [
      {
        internalType: "uint32",
        name: "oldestTimestamp",
        type: "uint32",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_asset",
        type: "address",
      },
      {
        internalType: "contract IUniswapV3Pool[]",
        name: "_pools",
        type: "address[]",
      },
    ],
    name: "setupAsset",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "newOwner",
        type: "address",
      },
    ],
    name: "transferOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "newPendingOwner",
        type: "address",
      },
    ],
    name: "transferPendingOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "uniswapV3Factory",
    outputs: [
      {
        internalType: "contract IUniswapV3Factory",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_asset",
        type: "address",
      },
      {
        internalType: "contract IUniswapV3Pool[]",
        name: "_pools",
        type: "address[]",
      },
    ],
    name: "verifyPools",
    outputs: [
      {
        components: [
          {
            internalType: "contract IUniswapV3Pool",
            name: "pool",
            type: "address",
          },
          {
            internalType: "bool",
            name: "token0IsInterim",
            type: "bool",
          },
        ],
        internalType: "struct UniswapV3PriceProviderV3.PricePath[]",
        name: "path",
        type: "tuple[]",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
];

export class UniswapV3PriceProviderV3__factory {
  static readonly abi = _abi;
  static createInterface(): UniswapV3PriceProviderV3Interface {
    return new utils.Interface(_abi) as UniswapV3PriceProviderV3Interface;
  }
  static connect(
    address: string,
    signerOrProvider: Signer | Provider
  ): UniswapV3PriceProviderV3 {
    return new Contract(
      address,
      _abi,
      signerOrProvider
    ) as UniswapV3PriceProviderV3;
  }
}
